import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { addPermittingData, addPermittingDataFailure, addPermittingDataSuccess, addPermittingRejectedData, addPermittingRejectedDataFailure, addPermittingRejectedDataSuccess, cancelPermittingRecord, cancelPermittingRecordFailure, cancelPermittingRecordSuccess, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createPermittingCommentRecord, createPermittingCommentRecordFailure, createPermittingCommentRecordSuccess, editPermittingData, editPermittingDataFailure, editPermittingDataSuccess, fetchPermittingAttachments, fetchPermittingAttachmentsFailure, fetchPermittingAttachmentsSuccess, fetchPermittingCancelReasonsList, fetchPermittingCancelReasonsListFailure, fetchPermittingCancelReasonsListSuccess, fetchPermittingFileAttachment, fetchPermittingFileAttachmentFailure, fetchPermittingFileAttachmentSuccess, fetchPermittingListData, fetchPermittingListFailure, fetchPermittingListSuccess, fetchPermittingMembersList, fetchPermittingMembersListFailure, fetchPermittingMembersListSuccess, fetchPermittingRecordComments, fetchPermittingRecordCommentsFailure, fetchPermittingRecordCommentsSuccess, fetchPermittingRecordholdunhold, fetchPermittingRecordholdunholdFailure, fetchPermittingRecordholdunholdSuccess, fetchPermittingRejectedListData, fetchPermittingRejectedListDataFailure, fetchPermittingRejectedListDataSuccess, fetchSinglePermittingRecordData, fetchSinglePermittingRecordDataFailure, fetchSinglePermittingRecordDataSuccess, releasePermittingRecord, releasePermittingRecordFailure, releasePermittingRecordSuccess, updatePermittingStatus, updatePermittingStatusFailure, updatePermittingStatusSuccess } from "./permitting.actions";
import { catchError, from, map, mergeMap, of, switchMap, tap } from "rxjs";
import { TokenStorageService } from "../../core/services/token-storage.service";
import { GenericService } from "../../core/services/generic.service";
import { and, collection, collectionData, or, orderBy, query, QueryCompositeFilterConstraint, where } from "@angular/fire/firestore";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { PermittingModel } from "../../core/models/permitting.models";
import { PermittingService } from "../../core/services/permitting.service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { ToastifyService } from "../../shared/toastify-service";
import { GlobalComponent } from "../../global-component";
import { FiltersService } from "../../core/services/filters.service";

@Injectable()
export class PermittingEffects {
    currentuser: any;
    firbasebasecollname: string = 'vendors';
    subdomaincollname: string = 'subdomains';
    vendorguid!: string;
    isdataoperator = false;

    constructor(
        private actions$: Actions,
        private tokenService: TokenStorageService,
        private genericService: GenericService,
        private afs: AngularFirestore,
        private permittingservice: PermittingService,
        private commonService: CommonAPIService,
        private toastifyService: ToastifyService,
        private filtersService: FiltersService
    ) { }

    // check condition
    async checkCondition(tabId: number) {
        console.log("--inside check condition--", tabId);
        this.currentuser = this.tokenService.getUser();
        this.isdataoperator = this.currentuser.isdataoperator;
        console.log("--current user inside check condition--", this.currentuser)
        const isuservendor = this.genericService.getUserIsVendor();
        const vendorCollection = collection(this.afs.firestore, `${this.firbasebasecollname}/${this.tokenService.getVendorGUID()!}/permittings`);
        console.log("---vendorCollection Line 30---", vendorCollection);
        let activestateval = true;
        if (tabId == 5) {
            activestateval = false;
        }

        let baseQuery = and(where('activestate', '==', activestateval));

        const filterData: any = this.filtersService.getPermittingSelectedFilters()

        // Adding Filter Queries to baseQuery
        if (filterData.clients && filterData.clients.length) {
            baseQuery = and(baseQuery, where("clientguid", 'in', filterData.clients))
        }

        if (filterData.states && filterData.states.length) {
            baseQuery = and(baseQuery, where("state", "in", filterData.states))
        }


        if (filterData.statuses && filterData.statuses.length) {
            baseQuery = and(baseQuery, where("jobstatus", "in", filterData.statuses))
        }

        if (filterData.daterange && filterData.daterange.length) {
            let queryby = ""
            switch (tabId) {
                case 1:
                    queryby = "createdAt"
                    break
                case 2:
                    queryby = "onholddate"
                    break
                case 4:
                    queryby = "deliverydate"
                    break
                default:
                    queryby = "createdAt"
            }
            let startDate = new Date(filterData.daterange[0].setHours(0, 0, 0, 0))
            let endDate = new Date(filterData.daterange[0].setHours(23, 59, 59, 999))
            console.log(startDate, endDate)
            if (filterData.daterange.length === 2) {
                endDate = new Date(filterData.daterange[1].setHours(23, 59, 59, 999))
            }

            baseQuery = and(baseQuery, where(queryby, ">=", startDate.toISOString()), where(queryby, "<=", endDate.toISOString()))
        }




        const userRoleCondition = where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
        let userRoleQuery: any = baseQuery;
        console.log("userrolequery111: ", userRoleQuery);
        let memberQuery: QueryCompositeFilterConstraint | null = null;

        console.log("condition test 1", !this.currentuser.usertype || !isuservendor, isuservendor, this.currentuser)
        if (!this.currentuser.usertype || !isuservendor) {
            userRoleQuery = and(userRoleCondition, where('activestate', '==', activestateval)) as QueryCompositeFilterConstraint;
        }

        switch (tabId) {
            case 1:
                if (!isuservendor) {
                    return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked', 'permittingrejected']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));
                }

                if (this.currentuser.isdataoperator) {
                    return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['accepted', 'interconnectioncompleted', 'permittingrejected']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));
                }

                return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['outsourced', 'accepted', 'picked','permittingrejected']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));

            case 2:
                return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['hold'])));

            case 3:
                if (this.currentuser.isdataoperator) {
                    return query(vendorCollection, and(userRoleQuery, where('isinrevisionstate', '==', false), where('jobstatus', 'in', ['interconnectioninprogress', 'permittinginprogress', 'ptorejected']), where('activeuserguid', '==', this.currentuser.guid)), orderBy("createdAt", "desc"));
                }

                return query(vendorCollection, and(userRoleQuery, where('isinrevisionstate', '==', false), where('jobstatus', 'in', ['interconnectioninprogress', 'permittinginprogress', 'interconnectioncompleted', 'ptorejected'])), orderBy("createdAt", "desc"));

            case 4:
                // Delivered list - To be done - indexing chanege required - activeuserguid will be changed to respective userguid
                // if(this.currentuser.isdataoperator) {
                //     return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false), where('activeuserguid', '==', this.currentuser.guid))), orderBy("deliverydate", "desc"));
                // }
                return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false))), orderBy("deliverydate", "desc"));

            case 5:
                return query(vendorCollection, userRoleQuery, orderBy("cancelleddate", "desc"));

            default:
                console.log('Invalid tabId:', tabId);
                return query(vendorCollection, baseQuery, orderBy("createdAt", "desc"));
        }
    }

    // Permitting List Effect Of Vendor
    // {
    // const collectionRef = collection(this.afs.firestore, `permittings/${tabId}/data`);
    // return collectionData<PermittingModel>(collectionRef).pipe(
    //     map((docs) => {
    //         console.log("docs", docs);
    //         console.log("tabId", tabId);
    //         return fetchPermittingListSuccess({ Permitting: docs, tabId });
    //     }),
    //     catchError((error) =>
    //         of(fetchPermittingListFailure({ error: error.message, tabId }))
    //     )
    // );
    // }

    // Create Permitting Record
    addPermittingData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addPermittingData),
            mergeMap(({ postdata }) =>
                this.permittingservice.addPermittingData(postdata).pipe(
                    map((Permittingrecord) => addPermittingDataSuccess(Permittingrecord)),
                    catchError((error) => of(addPermittingDataFailure({ error })))
                )
            ),
        ),
    );

    addPermittingDataSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addPermittingDataSuccess),
                tap((user: any) => {
                    this.toastifyService.showSuccessMessage("Order created successfully");
                })
            ),
        { dispatch: false }
    );

    addPermittingDataFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addPermittingDataFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // // Fetching permittings from firebase
    // fetchPermittingData$ = createEffect(() =>
    //     this.actions$.pipe(
    //       ofType(fetchPermittingListData),
    //       mergeMap(({ tabId }) =>
    //         from(this.checkCondition(tabId)).pipe(
    //           mergeMap(condition =>
    //             collectionData(condition).pipe(
    //               map((docs: any) => {
    //                 console.log("docs", docs);
    //                 console.log("tabId", tabId);
    //                 const permittings = docs.map((doc: PermittingModel) => doc);
    //                 return fetchPermittingListSuccess({ Permittings: permittings, tabid: tabId });
    //               }),
    //               catchError((error) =>
    //                 of(fetchPermittingListFailure({ error, tabid: tabId }))
    //               )
    //             )
    //           )
    //         )
    //       )
    //     )
    //   );

    // Refetch when the condition changes
    fetchPermittingData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPermittingListData),
            switchMap(({ tabId }) =>
                from(this.checkCondition(tabId)).pipe(
                    switchMap(condition =>
                        collectionData(condition).pipe(
                            map((docs: any) => fetchPermittingListSuccess({ Permittings: docs, tabid: tabId })),
                            catchError((error) => of(fetchPermittingListFailure({ error, tabid: tabId })))
                        )
                    )
                )
            )
        )
    );

    // Fetching and updating permittings status
    updatePermittingStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updatePermittingStatus),
            mergeMap(({ recordguid, postdata }) =>
                this.permittingservice.updatePermittingStatus(recordguid, postdata).pipe(
                    map(() => updatePermittingStatusSuccess()),
                    catchError((error) => of(updatePermittingStatusFailure({ error })))
                )
            ),
        ),
    );

    // Fetch permitting record
    fetchSinglePermittingRecordData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSinglePermittingRecordData),
            mergeMap(({ recordguid }) =>
                this.permittingservice.getSinglePermittingRecordData(recordguid).pipe(
                    map((permittingrecord) => fetchSinglePermittingRecordDataSuccess({ permittingrecord })),
                    catchError((error) => of(fetchSinglePermittingRecordDataFailure({ error })))
                )
            ),
        ),
    );

    // Comment create
    createPermittingCommentRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createPermittingCommentRecord),
            mergeMap(({ postdata }) =>
                this.commonService.createRecords('permittingcomments', postdata).pipe(
                    map((comment) => createPermittingCommentRecordSuccess({ comment })),
                    catchError((error) => of(createPermittingCommentRecordFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Permitting Comments Record
    fetchPermittingRecordComments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPermittingRecordComments),
            mergeMap(({ recordguid }) =>
                this.commonService.fetchRecords('permittingcomments', recordguid, 'createdAt:DESC').pipe(
                    map((comments) => fetchPermittingRecordCommentsSuccess({ comments: comments })),
                    catchError((error) => of(fetchPermittingRecordCommentsFailure({ error })))
                )
            ),
        ),
    );

    fetchPermittingRecordCommentsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPermittingRecordCommentsFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Fetch Permitting Comments Record
    fetchPermittingMembersList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPermittingMembersList),
            mergeMap(({ recordguid }) =>
                this.permittingservice.getPermittingsMembersList(recordguid).pipe(
                    map((list) => fetchPermittingMembersListSuccess({ memberslist: list })),
                    catchError((error) => of(fetchPermittingMembersListFailure({ error })))
                )
            ),
        ),
    );

    fetchPermittingMembersListFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPermittingMembersListFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // HOLD RECORD CREATE
    createHoldRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createHoldRecord),
            mergeMap(({ postdata }) =>
                this.commonService.createRecords('permittingholdjobs', postdata).pipe(
                    map((holdrecord: any) => createHoldRecordSuccess({ holdrecord })),
                    catchError((error) => of(createHoldRecordFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Permitting Hold/Unhold Record
    fetchPermittingRecordholdunhold$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPermittingRecordholdunhold),
            mergeMap(({ recordguid }) =>
                this.commonService.fetchRecords('permittingholdjobs', recordguid, 'createdAt:DESC').pipe(
                    map((holdunholdrecords) => fetchPermittingRecordholdunholdSuccess({ holdunhold: holdunholdrecords })),
                    catchError((error) => of(fetchPermittingRecordholdunholdFailure({ error })))
                )
            ),
        ),
    );

    // FETCH ATTACHMENTS OF Permitting RECORD
    fetchPermittingAttachments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPermittingAttachments),
            mergeMap(({ jobguid }) =>
                this.permittingservice.getPermittingsAttachments(jobguid).pipe(
                    map((attachments) => fetchPermittingAttachmentsSuccess({ attachments })),
                    catchError((error) => of(fetchPermittingAttachmentsFailure({ error })))
                )
            ),
        ),
    );

    fetchPermittingAttachmentsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPermittingAttachmentsFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // CANCEL PERMITTING PROJECT
    cancelPermittingRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(cancelPermittingRecord),
            mergeMap(({ postdata }) =>
                this.permittingservice.cancelPermittingProject(postdata).pipe(
                    map(() => cancelPermittingRecordSuccess()),
                    catchError((error) => of(cancelPermittingRecordFailure({ error })))
                )
            ),
        ),
    );

    cancelPermittingRecordSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(cancelPermittingRecordSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage(GlobalComponent.messages.cancelsuccess);
                })
            ),
        { dispatch: false }
    );

    cancelPermittingRecordFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(cancelPermittingRecordFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // FETCH CANCEL REASONS FROM FIREBASE
    fetchPermittingCancelReasonsList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPermittingCancelReasonsList),
            mergeMap(() =>
                this.afs.collection(GlobalComponent.firebasecancelreasonsbasecollname).doc('JnlKZBhKuN2yOmSiptTb')
                    .valueChanges().pipe(
                        map((docs: any) => {
                            console.log(":docs", docs)
                            return fetchPermittingCancelReasonsListSuccess({ reasons: docs });
                        }),
                        catchError((error) =>
                            of(fetchPermittingCancelReasonsListFailure({ error }))
                        )
                    )
            ),
        ),
    );

    fetchPermittingCancelReasonsListFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPermittingCancelReasonsListFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
                })
            ),
        { dispatch: false }
    );

    /**
   * RELEASE PLANSET RECORD
   */
    releasePermittingRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(releasePermittingRecord),
            mergeMap(({ recordguid, postdata }) =>
                this.permittingservice.releaserecord(recordguid, postdata).pipe(
                    map(() => releasePermittingRecordSuccess()),
                    catchError((error) => of(releasePermittingRecordFailure({ error })))
                )
            ),
        ),
    );

    releasePermittingRecordSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(releasePermittingRecordSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Record released successfully");
                    // this.router.navigate(['../']);
                })
            ),
        { dispatch: false }
    );

    releasePermittingRecordFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(releasePermittingRecordFailure),
                tap((error: any) => {
                    console.log('error', error);
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Edit Permitting Record
    editPermittingData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(editPermittingData),
            mergeMap(({ postdata, recordId }) =>
                this.permittingservice.editPermittingData(postdata, recordId).pipe(
                    map((Permittingrecord) => editPermittingDataSuccess(Permittingrecord)),
                    catchError((error) => of(editPermittingDataFailure({ error })))
                )
            ),
        ),
    );

    editPermittingDataSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editPermittingDataSuccess),
                tap((user: any) => {
                    this.toastifyService.showSuccessMessage("Order updated successfully");
                })
            ),
        { dispatch: false }
    );

    editPermittingDataFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editPermittingDataFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // FETCH ATTACHMENTS OF PERMITTING RECORD
    fetchPermittingFileAttachment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPermittingFileAttachment),
            mergeMap(({ jobguid }) =>
                this.permittingservice.getPermittingFile(jobguid).pipe(
                    map((attachments) => fetchPermittingFileAttachmentSuccess({ attachments })),
                    catchError((error) => of(fetchPermittingFileAttachmentFailure({ error })))
                )
            ),
        ),
    );

    fetchPermittingFileAttachmentFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPermittingFileAttachmentFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Add Permitting Rejected Record
    addPermittingRejectedData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addPermittingRejectedData),
            mergeMap(({ postdata }) =>
                this.permittingservice.addPermittingRejectedRecord(postdata).pipe(
                    map((record) => addPermittingRejectedDataSuccess({ record })),
                    catchError((error) => of(addPermittingRejectedDataFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Permitting Rejected List
    fetchPermittingRejectedListData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPermittingRejectedListData),
            mergeMap(({ postdata }) =>
                this.permittingservice.getRejectedList(postdata).pipe(
                    map((rejectedlist) => fetchPermittingRejectedListDataSuccess({ rejectedlist })),
                    catchError((error) => of(fetchPermittingRejectedListDataFailure({ error })))
                )
            ),
        ),
    );

}
